import { render, staticRenderFns } from "./OrderFollowerInformation.vue?vue&type=template&id=6699d434&scoped=true"
import script from "./OrderFollowerInformation.vue?vue&type=script&lang=js"
export * from "./OrderFollowerInformation.vue?vue&type=script&lang=js"
import style0 from "./OrderFollowerInformation.vue?vue&type=style&index=0&id=6699d434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6699d434",
  null
  
)

export default component.exports